enum Breakpoint {
  Mobile = 768,
  Desktop = 1024,
  LargeDesktop = 1280,
}

export default Breakpoint;
